import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Repairer,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/repairers`;

interface GetRepairersBySellerIdQueryArgs {
  sellerId: string;
  tenantId?: string;
  includeMasterRepairers?: boolean;
}

export default async function getRepairersBySellerIdQuery({
  sellerId,
  tenantId,
  includeMasterRepairers,
}: GetRepairersBySellerIdQueryArgs): Promise<
  BackResponse<Repairer[]> | BackResponseFailure
> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    return await apiCall<BackResponse<Repairer[]>>(
      buildUrl(url, {
        tenantId,
        includeMasterRepairers,
      }),
      { method: SUPPORTED_METHODS.GET },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
